<template>
  <div class="sparklecloud-anime-ios-container">
    <h1>元邦二次元小劇場 iOS</h1>
  </div>
</template>

<script>
export default {
  name: 'SparkleCloudAnimeIOS'
}
</script>

<style scoped>
.sparklecloud-anime-ios-container {
  padding: 20px;
  text-align: center;
}

h1 {
  color: #007aff;
  margin-bottom: 20px;
}
</style>
